import { render } from "./MobileMenuIcon.vue?vue&type=template&id=39744a98"
import script from "./MobileMenuIcon.vue?vue&type=script&lang=js"
export * from "./MobileMenuIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/saleem/Sites/WIMS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__